import React from "react";
import { bonuses, images } from "../data/content";

/* Faithful product visual built from real assets: 1 book cover + 5 bonus covers. */
export function ProductVisual({
  className = ""
}: {
  className?: string;
}) {
  return <figure className={`mx-auto w-full max-w-[440px] rounded-2xl bg-sage p-4 sm:p-5 ${className}`} data-id="element-149" data-mp="3sgvwrxa7jaha">
      <div className="flex items-stretch justify-center gap-3" data-id="element-150" data-mp="cjnyrzkq5hb">
        <img src={images.bookCover} alt="Cover of Volume 01 — Group Games & Social Fun" className="h-[240px] w-auto rounded-md border border-line bg-white shadow-[0_14px_30px_rgba(22,78,85,0.2)] sm:h-[320px] lg:h-[360px]" data-id="element-151" data-mp="o0uildeof8x5" />
        <ul className="flex flex-col justify-between" aria-label="5 bonus resources" data-id="element-152" data-mp="f6y8wy2p7oym">
          {bonuses.map(b => <li key={b.title} data-id="element-153" data-mp="1708cxwgbilo6">
              <img src={b.src} alt={b.title} loading="lazy" className="h-[44px] w-[44px] rounded-md object-cover shadow-[0_4px_10px_rgba(22,78,85,0.18)] sm:h-[60px] sm:w-[60px] lg:h-[66px] lg:w-[66px]" data-id="element-154" data-mp="16z5qq1txx7el" />
            </li>)}
        </ul>
      </div>
      <figcaption className="mt-4 rounded-xl bg-petrol px-4 py-3 text-center text-white" data-id="element-155" data-mp="1zf2upy1s1o7s">
        <span className="block font-display text-[22px] font-extrabold uppercase leading-none sm:text-2xl" data-id="element-156" data-mp="2e3qn5vgbthti">
          1 Activity Book + 5 Bonuses
        </span>
        <span className="mt-1.5 block text-[11px] font-semibold uppercase tracking-[0.16em] text-sage sm:text-xs" data-id="element-157" data-mp="2n2ay2afnan76">
          10 ready-to-lead activities
        </span>
      </figcaption>
    </figure>;
}